import React, { useEffect, useState } from "react"
import { Box, Button, Switch, TextField, Typography } from "@mui/material"
import DownloadIcon from "@mui/icons-material/Download"
import CustomTable from "../../../components/table/Table"
import { Add, Visibility } from "@mui/icons-material"
import { Link, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { fetchProductTemplates, updateProductTemplate } from "../../../redux/Slice/ProductTemplate"
import { setLoading } from "../../../redux/Slice/loaderSlice"
import CustomTable1 from "../../../components/table/CustomTable"
import { Edit } from "lucide-react"

const ProductTemplates = () => {
  const [searchQuery, setSearchQuery] = useState("")
  const [status, setStatus] = useState(false)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const rows = [
    { id: 1, name: "Basic Template" , status: "Active",
    },
    { id: 2, name: "Pro Template" , status: "Active",
    },
    { id: 3, name: "Premium Template",status: "Active",
    },
  ]
  const { Producttemplates }= useSelector(state => state.productTemplate)

  console.log(Producttemplates)
  const handleStatus = () => {
    setStatus(!status)
  }

  useEffect(() => {
    dispatch(setLoading(true))
    dispatch(fetchProductTemplates()).then(() => {
      dispatch(setLoading(false))
    })
  }, [])

  const updateTemplate =async (data, field, value) => {
    dispatch(setLoading(true))
    const updatedData = { ...data, [field]: value };
    
    console.log('Updated Data:', updatedData);
    await dispatch(updateProductTemplate({ id: updatedData._id, formData: updatedData }));
    dispatch(setLoading(false))
  }

  const handleView = (template) => {}

  const handleSearch = () => {
    console.log("Search query:", searchQuery)
  }

  const handleExport = () => {
    console.log("Exporting data...")
  }

  const columns = [
    {
      field: "template_id",
      headerName: "S.No",
      render: (value) => <strong>{value}</strong>,
    },
    {
      field: "templateName",
      headerName: "Template Name",
      render: (value) => <span>{value}</span>,
    },
    {
      field: "status",
      headerName: "Status",
      render: (value,row) => (
        <span>
          <Switch
            checked={value} // Assuming 'Active' means checked
            onChange={() => { updateTemplate(row, "status", !value) }}
            name="status"
          />
        </span>
      ),
    },
    {
      field: "isDefault",
      headerName: "Default",
      render: (value, row) => (
        <span>
          <Switch
            checked={value} // Check if it’s true or false
            onChange={() => { updateTemplate(row, "isDefault", !value)}} // Toggle isDefault
            name="isDefault"
          />
        </span>
      ),
    }
  ]

  const actions = [
    {
      icon: <Visibility />,
      onClick: (row) => {
        navigate(`/lead/${row._id}`);
      },
    },
    {
      icon: <Edit />,
      onClick: (row) => {
        console.log("Edit action clicked for:", row);
      },
    },
  ];

  

  return (
    <div className="content">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >

      <Typography variant="h5" sx={{ mb: 3, mt: 3 }}>
        Product Templates <Typography component="span">({rows.length})</Typography>
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {/* <TextField placeholder="Search by Name" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} fullWidth />
        <Button
          variant="contained"
          onClick={handleSearch}
          color="success"
          sx={{
            "&:hover": { backgroundColor: "#2FB354" },
          }}
        >
          Search
        </Button> */}
        <Button variant="contained" startIcon={<DownloadIcon />} onClick={handleExport} color="success" sx={{ ml: 2, px: 3, "&:hover": { backgroundColor: "#2FB354" } }}>
          Export
          </Button>
          <Link to="/datahub/product/template/add">
        <Button variant="contained" startIcon={<Add />}  color="success" sx={{ ml: 2, px: 3, "&:hover": { backgroundColor: "#2FB354" } }}>
          Add
        </Button>
          </Link>
      </Box>
      </Box>

      <CustomTable1
        columns={columns}
        actions={actions}
        apiCallFunction={fetchProductTemplates}
        searchForm={true}
        data={Producttemplates || []}
      />
    </div>
  )
}

export default ProductTemplates
